import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = '/api/v1';
const cache = new Map();

export function useSiteContent(slug) {
  const [page, setPage] = useState(cache.get(slug) || null);
  const [loading, setLoading] = useState(!cache.has(slug));
  const [error, setError] = useState(null);

  const fetchPage = useCallback(async () => {
    if (!slug) return;
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API}/content/${slug}`, { timeout: 30000 });
      const data = res.data?.data || null;
      cache.set(slug, data);
      setPage(data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to load content');
      setPage(null);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    if (cache.has(slug)) {
      setPage(cache.get(slug));
      setLoading(false);
      return;
    }
    fetchPage();
  }, [slug, fetchPage]);

  return { page, loading, error, refetch: fetchPage };
}

export function clearSiteContentCache(slug) {
  if (slug) cache.delete(slug);
  else cache.clear();
}
